import crud from "./crud";

const path = "suppliers";
const struct = {
  name: "",
  contact: "",
  address: "",
  phone1: "",
  phone2: "",
  phone3: "",
};
const generic = crud(path, struct);

const state = {
  ...generic.state,
};

const getters = {
  ...generic.getters,
};

const mutations = {
  ...generic.mutations,
};

const actions = {
  ...generic.actions,
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
